import FooterComponent from "../../component/Footer";

// -----------React hooks collection--------------------
import { useSelector } from "react-redux";
// -------------Data collection----------------------------
import AboutContainer from "./AboutContainer";
import { TestimonialCarossel } from "../../component/Carossel/Testimonial.carossel";

import SearchByCategory from "../../component/home/SearchByCategory";
import SearchByLocation from "../../component/home/SearchByLocation";
import Choices from "../../component/home/Choices";
import ProductSection from "../../component/home/ProductSection";
import { useFetchData } from "../../hooks/useFtechData";
import { ALL_JOB, ALL_STAT } from "../../resources/resource";
import { getJobByFunction, getJobsByLocations } from "./data";
import Hero from "./hero";
import Counter from "./countrt";
import Statistics from "./statistics";
import Notification from "./notification";
import Video from "./video";
import ApplicationStepContainer from "../application/ApplicationStepContainer";
import JobGrid from "../../component/JobGrid";
import JobSeekerStats from "../../component/job/JobSeekerStats";
import JobTitleCounts from "../../component/job/JobTitleCount";

function Homepage() {
  const allNotifications = useSelector(
    (state) => state.notification.notificationList
  );

  // ---------Pagination data----------
  const { data: jobData } = useFetchData(ALL_JOB);
  const { data: statData } = useFetchData(ALL_STAT);

  return (
    <div className="">
      {/* ----------------Hero Section---------------- */}
      <Hero />

      {/* ------------Job section------------- */}
      <Counter statData={statData} />


       {/* ------------Job posted------------- */}
      <JobGrid />
      {/* -------------------Job by job category------------------------- */}
      <section className="my-20 w-full px-5 sm:px-20 py-16 bg-gray-50">
        <SearchByCategory data={getJobByFunction(jobData)} />
      </section>

      {/* --------------------Job by location----------------------- */}

      <section className="my-20 bggreen-50 py-16 px-5 sm:px-20">
        <SearchByLocation data={getJobsByLocations(jobData)} />
      </section>

      <JobSeekerStats  />
      <JobTitleCounts />

      {/* ---------------Advert section---------------- */}
      <section className="sm:px-20 px-5">
        <p className="w-full border-2 border-slate-500 h-60">Adds here</p>
      </section>

      {/* --------------- */}
      <ApplicationStepContainer />

      {/* -------------Video section--------------- */}
      <Video />

      {/* ----------------Choices Section------------------- */}
      <section className="my-20 sm:px-20 px-5 border-t-4 py-4 border-b-4 border-green-500">
        <Choices />
      </section>

      {/* ------------Job search section------------- */}

      {/* ------------Advert Section--------------------- */}
      <section className="w-full h-64 border-2 py-10 sm:px-20 px-5">
        <p>This is an adverts</p>
      </section>

      {/* ----------------About section------------- */}
      <AboutContainer />

      {/* --------------Product Section----------------- */}
      <section className="my-20 sm:px-20 px-5">
        <ProductSection />
      </section>

      {/* -------------------Testimonial Page-------------------- */}
      <section className="bg-slate-300 my-20 sm:px-20 py-10">
        <h3 className="mx-auto mb-8 text-xl font-semibold border-b-2 border-green-500 w-fit">
          Happy Employers
        </h3>
        <TestimonialCarossel />
      </section>

      {/* ------------------Statistic Section-------------------- */}
      <Statistics statData={statData} />
      {/* ----------------Notification section----------------- */}
      <Notification allNotifications={allNotifications} />

      <FooterComponent />
    </div>
  );
}

export default Homepage;
